"use client";

import { Carousel, CarouselContent, CarouselItem } from "@templates/design-system";
import AutoScroll from "embla-carousel-auto-scroll";
import { useRef } from "react";
import { getComponent } from "../../../../client";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import type { ILogoCloudCarouselProps } from "./LogoCloudCarousel.props";

export const LogoCloudCarousel = ({ items }: ILogoCloudCarouselProps) => {
  const Link = getComponent("Link");
  const autoScroll = useRef(
    AutoScroll({
      direction: "backward",
      playOnInit: true,
      speed: 1.5,
      startDelay: 0,
      stopOnFocusIn: true,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );
  const repeatedItems = [
    ...items.map((item) => ({ hidden: false, item })),
    ...items.map((item) => ({ hidden: true, item })),
  ];

  return (
    <Carousel
      aria-label="Affiliated organizations"
      className="woha-logo-carousel"
      opts={{ align: "start", dragFree: true, loop: true }}
      plugins={[autoScroll.current]}
      tabIndex={0}
    >
      <CarouselContent className="-ml-6" viewportClassName="py-4">
        {repeatedItems.map(({ hidden, item }, index) => {
          const logo = (
            <WohaMedia
              className="h-24 w-52 rounded-xl border border-ash bg-white p-6"
              imageClassName="object-contain grayscale transition-[filter] duration-200 group-hover:grayscale-0"
              media={item.logo}
              sizes="208px"
            />
          );

          return (
            <CarouselItem
              aria-hidden={hidden || undefined}
              className="basis-auto pl-6"
              key={`${hidden ? "repeat" : "authored"}-${index}`}
            >
              {item.logoLink && !hidden ? (
                <Link
                  aria-label={item.logoLink.accessibilityLabel || undefined}
                  className="group block rounded-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-blue"
                  href={item.logoLink.href}
                  rel={item.logoLink.openInNewTab ? "noopener noreferrer" : undefined}
                  target={item.logoLink.openInNewTab ? "_blank" : undefined}
                >
                  {logo}
                </Link>
              ) : (
                logo
              )}
            </CarouselItem>
          );
        })}
      </CarouselContent>
    </Carousel>
  );
};
LogoCloudCarousel.displayName = "Content::LogoCloudCarousel";
